import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Welcome to the Demo",
description: "Access the live Freon demo and explore recorded presentations, including the MDENet session from May 2023 showcasing Freon’s editor capabilities.",
tags: [ "Freon", "demo", "editor", "live example", "MDENet", "presentation", "documentation", "showcase", "web app"] ,
modifiedTime: "2025-11-07T17:20:18.645Z",
publishedTime: "2025-11-07T17:20:18.645Z"
    }
  };
};